import React from 'react';
import { Spinner } from '@chakra-ui/react';

const LoadingButton = () => (
    <div style={{ height: '10px', display: 'flex', justifyContent: 'center', marginTop: '13px', marginLeft:'5px',alignItems: 'center' }}>
        <Spinner size="md" />
    </div>
)

export default LoadingButton;